import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import LocaleTooling from '../../../tooling/localeTooling';
import FormatTooling from '../../../tooling/formatTooling';
import Constants from '../../../definitions/constants';

import GlassPopup from '../common/interface/glassPopup';
import FieldInfo from '../common/inputs/fieldInfo';
import MetricDataTable from './metricDataTable';
import Spinner from '../common/interface/spinner';
import Button from '../common/inputs/button';

const getNodeRows = (node, handleOpenClose, handleDecompressNode, handleGetMetricData, markedMetric, paddingTree = 0) => {
  let nodeRows = [];
  if(node && node.show) {
    let has_childs = (node.childs && node.childs.length>0) ? true : false;
    let is_open = (has_childs && node.childs[0].show) ? true : false;
    let nodeValue = FormatTooling.defaultsTextFormatTypes(node.value,Constants.crudGenerator.dataTypes.NUMBER)
    let nodeValueAllDecimals = FormatTooling.defaultsTextFormatTypes(node.value,Constants.crudGenerator.dataTypes.NUMBER_ALL_DECIMALS)
    let errorsToShow = node.errors ? node.errors.map(item => item.message) : []
    errorsToShow = errorsToShow.concat(node.ignored_errors ? node.ignored_errors.map(item => item.message) : [])
    nodeRows.push((
      <tr 
        data-id={node.id} 
        onClick={has_childs ? handleOpenClose : (node.type_code == "CompressedNode" ? handleDecompressNode : null)} 
        key={"row" + node.id} 
        className={((node.child_has_error || (node.errors && node.errors.length>0)) ? "table_color_row_red" : "") + 
                  (!has_childs ? " non_clickable" : "") +
                  (node.markError ? " depuration_tree_marked_error" : "") +
                  ((node.id==markedMetric) ? " depuration_tree_marked_metric" : "") +
                  (node.type_code == "CompressedNode" ? "depuration_tree_compressed_node" : "")}
      >
        <td className="calculation_detail_popup_node_column">
          <div style={{paddingLeft: (paddingTree + "px")}} title={node.type}>
            {has_childs && (
              <i 
                data-id={node.id}
                className={"fas fa-" + (is_open ? "minus-square" : "plus-square")}
              />
            )}
            {(node.type_code == "CompressedNode") && (
              <i 
                data-id={node.id}
                className={"fas fa-box-open"}
              />
            )}
            {node.type}
            {((node.type_code == "MetricNode" || node.type_code == "MetricCalculationNode")  && !node.not_calculated && !node.dimension_not_defined) && (
              <i 
                data-nodedata={JSON.stringify(node)}
                onClick={handleGetMetricData} 
                className={"fas fa-eye"}
              />
            )}
          </div>
        </td>
        <td><div title={node.formula}>{node.formula}</div></td>
        <td className="align_center"><div title={nodeValueAllDecimals}>{nodeValue}</div></td>
        <td><div title={errorsToShow.join(" | ")}>{errorsToShow.join(" | ")}</div></td>
        <td><div title={node.duration}>{FormatTooling.defaultsTextFormatTypes(node.duration,Constants.crudGenerator.dataTypes.NUMBER)}</div></td>
      </tr>
    ));
    if(node.childs) {
      node.childs.forEach(childNode => {
        nodeRows = nodeRows.concat(getNodeRows(childNode, handleOpenClose, handleDecompressNode, handleGetMetricData, markedMetric, paddingTree+7));
      });
    }
  }
  return nodeRows;
};

const CalculationDetailPopup = props => {
  const {
    handleShowPopup,
    fullLoading,
    calculationDetailData,
    calculationDetailPopupTree,
    calculationDepurationDetailMetricData,
    handleOpenClose,
    handleDecompressNode,
    handleGoToError,
    handleCloseAll,
    handleGetMetricData,
    fetchMetricsDataNextPage,
    showMetricsPanel,
    markedMetric,
    handleCloseMetricData,
    handleExportMetricsData,
    loadingExportMetricData,
    popupTitle,
    popupState
  } = props;
  let hasErrorClass = calculationDetailData.has_error ? "calculation_has_error" : "";
  return (
    <GlassPopup
      className="form_popup calculation_detail_popup full_screen_popup"
      title={popupTitle ? popupTitle : intl.formatMessage({id: "calculationsHistory.calculationDetailPopup.title"})}
      {...props}
    >
      {(calculationDetailData.no_debug_tree) ? (
        <div className="no_period_selected_wrapper">
          {intl.formatMessage({ id: "calculationsHistory.calculationInstancesDetail.noDebugTreeHelp" })}
          {(calculationDetailData.calculate_params.polynomial_id) ? (
            <React.Fragment>
              <p>{intl.formatMessage({ id: "calculationsHistory.calculationInstancesDetail.noDebugTreeHelpTemp" })}</p>              
              <p>{intl.formatMessage({ id: "calculationsHistory.calculationInstancesDetail.noDebugTreeHelp3" })}</p>
            </React.Fragment>
          ) : (calculationDetailData.calculate_params.polynomial_sub_model_id) ? (
            <React.Fragment>
              <p>{intl.formatMessage({ id: "calculationsHistory.calculationInstancesDetail.noDebugTreeHelpPreModelTemp" })}</p>              
              <p>{intl.formatMessage({ id: "calculationsHistory.calculationInstancesDetail.noDebugTreeHelp3" })}</p>
            </React.Fragment>
          ) : null}
        </div>
      ) : (calculationDetailData.id) ? (
        <div className="calculation_detail_popup_inner">
          <div className="calculation_detail_popup_left_panel">
            <FieldInfo 
              label={(<FormattedMessage id="calculationsHistory.fields.created_at"/>)}
              value={FormatTooling.defaultsTextFormatTypes(calculationDetailData.calculation_date,Constants.crudGenerator.dataTypes.DATETIME)}
              showDataTooltip={true}
            />
            <FieldInfo 
              label={(<FormattedMessage id="calculationsHistory.fields.period"/>)}
              value={calculationDetailData.period_name}
              showDataTooltip={true}
            />
            <FieldInfo 
              label={calculationDetailData.pivot_dimension_name}
              value={calculationDetailData.calculation_unit_id ? calculationDetailData.calculation_unit_name : calculationDetailData.dimension_instance}
              showDataTooltip={true}
            />
            <FieldInfo 
              label={(<FormattedMessage id="calculationsHistory.fields.polynomial"/>)}
              value={calculationDetailData.polynomial_name}
              showDataTooltip={true}
            />
            <FieldInfo 
              label={(<FormattedMessage id="calculationsHistory.fields.value"/>)}
              value={FormatTooling.defaultsTextFormatTypes(calculationDetailData.value,Constants.crudGenerator.dataTypes.NUMBER)}
              className={hasErrorClass}
              showDataTooltip={true}
            />
            <FieldInfo 
              label={(<FormattedMessage id="calculationsHistory.fields.detail"/>)}
              value={FormatTooling.defaultsTextFormatTypes(calculationDetailData.detail_value,Constants.crudGenerator.dataTypes.NUMBER)}
              showDataTooltip={true}
            />
            <FieldInfo 
              label={(<FormattedMessage id="calculationsHistory.fields.goal"/>)}
              value={FormatTooling.defaultsTextFormatTypes(calculationDetailData.goal_value,Constants.crudGenerator.dataTypes.NUMBER)}
              showDataTooltip={true}
            />
            {(calculationDetailData.has_error) && (
              <div className="errors_block">
                <div className={"calculation_detail_label_separator " + hasErrorClass}>
                  <FormattedMessage id="calculationsHistory.calculationDetailPopup.errorsLabel"/>
                </div>
                <ul>
                {calculationDetailData.errors.map((item, i) => {
                  return (
                    <li 
                      data-id={item.error_anchor_id}
                      key={"errors" + i} 
                      className={"calculation_detail_error_text " + hasErrorClass}
                      onClick={handleGoToError}
                    >
                      {item.message + " - "}
                      <FormattedMessage id="calculationsHistory.calculationDetailPopup.goToError"/>
                    </li>
                  );
                })}
                </ul>
              </div>
            )}
            <div className="dimensions_block">
              <div className={"calculation_detail_label_separator"}>
                <FormattedMessage id="calculationsHistory.calculationDetailPopup.instanciatedDimensionsLabel"/>
              </div>
              <ul>
              {calculationDetailData.dimensions_instanciated.map((item, i) => {
                return (<li key={"dimensions" + i} className={"calculation_detail_dimension_text"}>
                    <span>{item.name + ": "}</span>{(item.system_dimension_value ? item.system_dimension_value : FormatTooling.metricDatasFormatTypes(item.value,item.type))}
                </li>);
              })}
              </ul>
            </div>  
            {(calculationDetailData.calculation_unit_id) && (
              <div className="metrics_block">
                <div className={"calculation_detail_label_separator"}>
                  {LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="calculationsHistory.calculationDetailPopup.calculationUnitMetrics"/>)}
                </div>
                <ul>
                {calculationDetailData.system_dimension_metrics.map((item, i) => {
                  return (<li key={"metrics" + i} className={"calculation_detail_metrics_text"}>
                      <span>{item.metric_name + ": "}</span>{FormatTooling.metricDatasFormatTypes(item.metric_value,item.validation_dimension_type ? item.validation_dimension_type : item.metric_data_type )}
                  </li>);
                })}
                </ul>
              </div>
            )}
          </div>
          <div className="calculation_detail_popup_right_panel">
            <div className="calculation_detail_popup_right_top_panel">
              <div className={"calculation_detail_label_separator"}>
                <FormattedMessage id="calculationsHistory.calculationDetailPopup.astTreeTitle"/>
                <span className="simulated-a" onClick={handleCloseAll}><FormattedMessage id="calculationsHistory.calculationDetailPopup.collapseAll"/></span>
              </div>
              <div className={"table_component"}>
                <div className="table_component_table_wrapper">
                  <div className="table_component_table_header_wrapper">
                    <table>
                      <thead>
                        <tr>
                          <th className="calculation_detail_popup_node_column">
                            <div><FormattedMessage id="calculationsHistory.calculationDetailPopup.headers.nodeType"/></div>
                          </th>
                          <th className="calculation_detail_popup_formula_column">
                            <div><FormattedMessage id="calculationsHistory.calculationDetailPopup.headers.formula"/></div>
                          </th>
                          <th className="calculation_detail_popup_value_column">
                            <div><FormattedMessage id="calculationsHistory.calculationDetailPopup.headers.value"/></div>
                          </th>
                          <th className="calculation_detail_popup_errors_column">
                            <div><FormattedMessage id="calculationsHistory.calculationDetailPopup.headers.errors"/></div>
                          </th>
                          <th className="calculation_detail_popup_duration_column">
                            <div><FormattedMessage id="calculationsHistory.calculationDetailPopup.headers.duration"/></div>
                          </th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                  <div className="table_component_table_body_wrapper">
                    <table>
                      <thead>
                        <tr>
                          <th className="calculation_detail_popup_node_column">{""}</th>
                          <th className="calculation_detail_popup_formula_column">{""}</th>
                          <th className="calculation_detail_popup_value_column">{""}</th>
                          <th className="calculation_detail_popup_errors_column">{""}</th>
                          <th className="calculation_detail_popup_duration_column">{""}</th>
                        </tr>
                      </thead>
                      <tbody>
                      {getNodeRows(calculationDetailPopupTree, handleOpenClose, handleDecompressNode, handleGetMetricData, markedMetric)}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {(showMetricsPanel) && (
              <div className="calculation_detail_popup_right_separator_panel">
                <i
                  onClick={handleCloseMetricData} 
                  className={"fas fa-times"}
                />
                <Button
                  loading={loadingExportMetricData}
                  disabled={calculationDepurationDetailMetricData.status!=200 || 
                    calculationDepurationDetailMetricData.loading || loadingExportMetricData}
                  onClick={handleExportMetricsData}
                  labelLocale={<FormattedMessage id="metricDataAdmin.exportButtonTitle"/>}
                />
              </div>
            )}
            {(showMetricsPanel) && (
              <div className="calculation_detail_popup_right_bottom_panel">
                <div className={"calculation_detail_label_separator"}>
                  <FormattedMessage id="calculationsHistory.calculationDetailPopup.metricDataTitle"/>
                  {(calculationDepurationDetailMetricData.status == 200 || 
                      calculationDepurationDetailMetricData.paginationStatus!=null) ? 
                    (" '" + calculationDepurationDetailMetricData.additionalData.metric_name + "'") :""
                  }
                  <span>
                    <FormattedMessage id="calculationsHistory.calculationDetailPopup.metricDataFiltersTitle"/>
                    {(calculationDepurationDetailMetricData.status == 200 || 
                        calculationDepurationDetailMetricData.paginationStatus!=null) ? 
                      (" " + calculationDepurationDetailMetricData.additionalData.query_info.map(item => {
                       return item.name + ": " + (item.is_negation ? "!" : "") + 
                        (item.system_dimension_value ? item.system_dimension_value : FormatTooling.metricDatasFormatTypes(item.value,item.type));
                      }).join(" | ")) : ""
                    }
                  </span>
                </div>
                {(calculationDepurationDetailMetricData.status == 200 || 
                  calculationDepurationDetailMetricData.paginationStatus!=null) && (
                  <MetricDataTable
                    data={calculationDepurationDetailMetricData.data}
                    additionalData={calculationDepurationDetailMetricData.additionalData}
                    loading={calculationDepurationDetailMetricData.loading}
                    page={calculationDepurationDetailMetricData.page}
                    totalPages={calculationDepurationDetailMetricData.totalPages}
                    totalRecords={calculationDepurationDetailMetricData.totalRecords}
                    fetchListChangePage={fetchMetricsDataNextPage}
                  />
                )}
                {(calculationDepurationDetailMetricData.loading && calculationDepurationDetailMetricData.paginationStatus==null) && (
                  <div className="loading_metrics_wrapper info_loading_metrics_panel">
                    <Spinner/>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      ) : null }
    </GlassPopup>
  );
};

export default CalculationDetailPopup;



// WEBPACK FOOTER //
// ./source/client/components/calculationsHistory/calculationDetailPopup.jsx